import React, { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Form, Formik, ErrorMessage } from "formik";
import { createPasswordSchema } from '../../utils/yup';
import CloseIcon from "../icons/CloseIcon";
import { useLocation } from "react-router-dom";
import { fetchUserData, acceptInvite, setUser, loadCartListDetails } from "../../redux/actions";
import { useDispatch } from "react-redux";
import { toast } from 'react-toastify';

const useQueryParams = () => {
    return new URLSearchParams(useLocation().search);
};

const SignUpPage = () => { 
    const query = useQueryParams();
    const token = query.get("token");
    const email = query.get("email");
    const navigate                                       = useNavigate();
    const [showPassword, setShowPassword]                = useState(false);
    const [showConfirmPassword, setShowConfirmPassword]  = useState(false);
    const [loading, setLoading]                          = useState(false);  
    const dispatch                                       = useDispatch();  
    

    const onSubmit = async (values, { setSubmitting }) => {
        try {   
            setLoading(true);

            values.token = token;
            values.email = email;

            const result  = await acceptInvite(values);
            
            if(result?.token) {                
                localStorage.setItem("auth_token", result.token);
                
                // ✅ Ensure token is available before proceeding
                await new Promise((resolve) => setTimeout(resolve, 100)); // Small delay to ensure cookie is set

                if(localStorage.getItem("auth_token")) {
                    const user_data = await fetchUserData();

                    if(user_data?.message) {
                        toast.error(user_data?.message);
                    } else {
                        dispatch(setUser(user_data));

                        if(user_data?.shopping_carts) {
                            await loadCartListDetails(user_data?.shopping_carts, dispatch);
                        }
                    
                        navigate("/self-service/dashboard");     
                        toast.success("You have been signed in successfully!");        
                    }
                }                          
            } else {
                toast.error(result?.message);
            }

            setLoading(false);
        } catch (error) {     
            setLoading(false);            
            console.log(error);  
        }

        setSubmitting(false);
    };   

    return (
        <section className="account py-40">
            <Formik
                initialValues={{
                    token : '', 
                    password: '', 
                    password_confirmation: ''
                }}
                onSubmit={onSubmit}
                validationSchema={createPasswordSchema}
            >
                {({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
                    <Form>
                        <div className="container container-lg">            
                            <div className="row gy-4">
                                {/* Confirm invitation Card Start */}
                                <div className="col-xl-3"></div>
                                <div className="col-xl-5">
                                    <div className="row gy-4">
                                        <div className="col-xl-6">
                                            <div className="logo px-16 d-block">
                                                <Link to='/' className='mobile-menu__logo'>
                                                    <img src='../../assets/images/logo/dhofar-logo.svg' alt='Logo' />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 d-flex justify-content-end align-items-center">
                                            <Link to='/'>
                                                <CloseIcon size={14} className='text-neutral-900' />
                                            </Link>
                                        </div>
                                    </div>
                                    <h4 className="text-center"><b>Create Password</b></h4>  
                                    <div className="product-dContent border rounded-24 p-20"> 
                                        <div className="mb-40">   
                                            <div className="mb-24">
                                                <div className="row">
                                                    <div className="pt-20 pb-20">Welcome&nbsp;<b>{email}</b>. Before you can start browsing self service you need to create password for your account.</div>
                                                    <label
                                                        htmlFor="password"
                                                        className="lable-font text-neutral-900 mb-8 fw-medium"
                                                    >
                                                        Password <span className="text-danger">*</span>
                                                    </label>
                                                    <div className="position-relative">
                                                        <input
                                                            type={showPassword ? "text" : "password"} // Toggle between text and password
                                                            className="common-input input-font"
                                                            id="password"
                                                            placeholder="Enter password"
                                                            name="password"                                                                        
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.password}
                                                            autoComplete="new-password" 
                                                        />
                                                        {/* Toggle button */}
                                                        <span
                                                            className={`toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ${
                                                                showPassword ? "ph-eye" : "ph-eye-slash"
                                                            }`}
                                                            onClick={() => setShowPassword(!showPassword)}
                                                            style={{ cursor: "pointer" }}
                                                        />
                                                        {errors.password && touched.password && (
                                                            <ErrorMessage name="password" component="div" className="text-danger" />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mb-24">
                                                <div className="row">
                                                    <label
                                                        htmlFor="password"
                                                        className="lable-font text-neutral-900 mb-8 fw-medium"
                                                    >
                                                        Password confirmation <span className="text-danger">*</span>
                                                    </label>
                                                    <div className="position-relative">
                                                        <input
                                                            type={showConfirmPassword ? "text" : "password"} // Toggle between text and password
                                                            className="common-input input-font" 
                                                            id="password"
                                                            placeholder="Enter confirm password"
                                                            name="password_confirmation"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.password_confirmation}
                                                            autoComplete="new-password" 
                                                        />
                                                            {/* Toggle button */}
                                                            <span
                                                            className={`toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ${
                                                                showConfirmPassword ? "ph-eye" : "ph-eye-slash"
                                                            }`}
                                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                            style={{ cursor: "pointer" }}
                                                        />
                                                        {errors.password_confirmation && touched.password_confirmation && (
                                                            <ErrorMessage name="password_confirmation" component="div" className="text-danger" />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="text-center">
                                                <button type="submit" className="btn btn-main py-16 px-30 w-full" disabled={loading} >
                                                    Save Password
                                                </button>
                                            </div>
                                        </div>    
                                    </div>                         
                                </div>
                                {/* Confirm invitation Card End */}
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </section>
    );
};

export default SignUpPage;
